import React from 'react';
import Section from './section';
import PieChart from './pieChart';

interface iBrakingSpeedAnalysisProps {
    speedDistribution?: any;
    speedDescription?: string;
}

// 制动速度分析模块
const BrakingSpeedAnalysis = (props: iBrakingSpeedAnalysisProps) => {
    const { speedDistribution, speedDescription = '' } = props;





    // 如果没有数据，显示默认提示
    if (!speedDistribution || speedDistribution.length === 0) {
        return (
            <Section title="八、制动速度分析">
                <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                    暂无制动速度分析数据
                </div>
            </Section>
        );
    }

    return (
        <Section title="八、制动速度分析" >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <PieChart
                    data={speedDistribution}
                    title="制动速度分布"
                    isRing={true}
                    style={{ width: '500px', height: '400px' }}
                    colors={['#91cc75', '#fac858', '#ee6666']}
                    showLabel={true}
                    labelPosition="outside"
                    legendPosition="bottom"
                    legendOrient="horizontal"
                />
            </div>


            {speedDescription && (
                <div style={{ marginTop: '20px' }}>
                    <h4>分析结果</h4>
                    <div style={{
                        lineHeight: '1.6',
                        color: '#666',
                        whiteSpace: 'pre-line',
                        padding: '12px',
                        backgroundColor: '#f6f8fa',
                        borderRadius: '4px'
                    }}>
                        {speedDescription}
                    </div>
                </div>
            )}

            {!speedDescription && speedDistribution.length > 0 && (
                <div style={{ marginTop: '20px' }}>
                    <h4>分析结果</h4>
                    <div style={{
                        lineHeight: '1.6',
                        color: '#666',
                        padding: '12px',
                        backgroundColor: '#f6f8fa',
                        borderRadius: '4px'
                    }}>
                        {
                            speedDescription
                        }

                    </div>
                </div>
            )}
        </Section>
    );
};

export default BrakingSpeedAnalysis;
